import Utilities from './Utilities';
const FIREBASE_FUNCTIONS_URL = 'https://us-central1-gottea-3daa4.cloudfunctions.net';
const ELASTIC_SEARCH_URL = 'https://cors.zimjs.com/https://gottea-analytics.es.asia-south1.gcp.elastic-cloud.com:9243';
const ELASTIC_SEARCH_API_KEY = 'ZWxhc3RpYzpQSHc0dWdpY0NPUFI0UHdiNG1BSzdkSEw=';
const API_BASE_URL = 'https://gottea-search-5gtrn.ondigitalocean.app';

function makeMatchArray(matchObj){
    let matchArr = [];   
    for(const key in matchObj){
      let temp = {terms:{}};
      const filterArray = matchObj[key];
      temp.terms[key] = filterArray;
      matchArr.push(temp);
    }
    return matchArr;
}

function makeDateRangeArray(dateKey, startDate, endDate){
  let matchArr = [];   
  const rangeFilter = {
    range : {
    [dateKey] : {
      "gte" : startDate,
      "lte" : endDate
    }
  }};
  matchArr.push(rangeFilter);
  return matchArr;
}

function makeWilcardQueryArray(searchTerm , terms){
    let finalArr = [];
    const words = searchTerm.trim().split(" ");
    for(let term of terms){
      let matchArr = [];
      for(let word of words){
        const searchObj = {
          wildcard: {
            [term]: `*${word}*`
          }
        };
        matchArr.push(searchObj);
      }
      finalArr.push({ bool : { must : matchArr }});
    }
    return finalArr;
}


export default class Api {
    async getGoalData(goalKey){
        return await Utilities.makeWebRequest(`${FIREBASE_FUNCTIONS_URL}/sales/goal`,'POST', {
        goalKey
        });
    }

    async getGotTeaOrderDataDayWise(startTime, endTime, branchName){
        return await Utilities.makeWebRequest(`${API_BASE_URL}/sales/daywise`,'POST', {
        startTime,
        endTime,
        branchName
        });
    }


    async getGotTeaOrderData(startTime, endTime, selectedBranches){
        return await Utilities.makeWebRequest(`${API_BASE_URL}/sales/branchwise`,'POST', {
        startTime,
        endTime,
        selectedBranches
        });
    }

    async getCustomerData(startTime, endTime){
        return await Utilities.makeWebRequest(`${FIREBASE_FUNCTIONS_URL}/customers/gottea`,'POST', {
        startTime,
        endTime
        });
    }

    async createMaterial(fields){
        return await Utilities.makeWebRequest(`${API_BASE_URL}/materials`,'POST', fields);
    }

    async deleteMaterial(materialId){
        return await Utilities.makeWebRequest(`${API_BASE_URL}/materials`,'DELETE', {id:materialId});
    }

    async updateMaterial(materialId,fields){
        return await Utilities.makeWebRequest(`${API_BASE_URL}/materials`,'PUT', {id:materialId,...fields});
    }

    async getMaterial(materialId){
        return await Utilities.makeWebRequest(`${API_BASE_URL}/materials/${materialId}`,'GET');
    }

    async searchIndex(indexName, searchTerm = '', terms, offset = 0, size = 1000, sort = null, filters = null, dateRange = null){
        searchTerm = Utilities.cleanText(searchTerm);
        const searchObj = () => {  
          let wildcardQuery,obj = {};
          obj.headers =  {'Content-Type': 'application/json', 'Authorization' : `Basic ${ELASTIC_SEARCH_API_KEY}` };
          if(!Utilities.isNullOrEmpty(searchTerm)){
            wildcardQuery= makeWilcardQueryArray(searchTerm, terms);
            obj = { query : { 
              bool: { should : wildcardQuery} 
            }}
          }
          
          if(!Utilities.isNullOrEmpty(searchTerm) && (!Utilities.isNullOrEmpty(filters) || !Utilities.isNullOrEmpty(dateRange))){
            obj.query = {
              bool : {
                must : [
                  {bool: { should : wildcardQuery}}
                ] 
              }
            }
            if(!Utilities.isNullOrEmpty(filters)){
              obj.query.bool.must = obj.query.bool.must.concat(makeMatchArray(filters));
            }
            if(!Utilities.isNullOrEmpty(dateRange)){
              obj.query.bool.must = obj.query.bool.must.concat(makeDateRangeArray(dateRange.key || 'createdAt',dateRange.startDate, dateRange.endDate));
            }
          }
  
          if(Utilities.isNullOrEmpty(searchTerm) && (!Utilities.isNullOrEmpty(filters) || !Utilities.isNullOrEmpty(dateRange))){
            obj.query = {
              bool : {
                must : []
              }
            }
            if(!Utilities.isNullOrEmpty(filters)){
              obj.query.bool.must = obj.query.bool.must.concat(makeMatchArray(filters));
            }
            if(!Utilities.isNullOrEmpty(dateRange)){
              obj.query.bool.must = obj.query.bool.must.concat(makeDateRangeArray(dateRange.key || 'createdAt',dateRange.startDate, dateRange.endDate));
            }
          }
  
          if(!Utilities.isNullOrEmpty(sort)){
            obj.sort = sort;
          }
          
          return obj;
        };      

        return new Promise(async (resolve, reject) => {
            try {
                const body = await Utilities.makeWebRequest(`${ELASTIC_SEARCH_URL}/${indexName}/_search?from=${offset}&size=${size}&scroll=1m`,'GET', searchObj(), false); // false = don't include Firebase auth for ElasticSearch
                const data = body.hits.hits.map((item)=>{
                      const obj = item._source;
                      obj.id = item._id;
                      return obj;
                });
                const result = {
                    count: data.length,
                    scrollId : body._scroll_id,
                    totalCount : body.hits.total.value,
                    data
                }
                resolve(result);
            } catch(err) {
                reject(err);
            }
        });
    }

    async createNewAction(actionData){
        return await Utilities.makeWebRequest(`${API_BASE_URL}/actions`,'POST', actionData);
    }

    async updateAction(actionId,fields){
        return await Utilities.makeWebRequest(`${API_BASE_URL}/actions/commissary`,'PUT', {id:actionId,...fields});
    }

    async getRecipeConfig(){
        return await Utilities.makeWebRequest(`${API_BASE_URL}/config/recipeConfig`,'GET');
    }

    async getBranches(){
        return await Utilities.makeWebRequest(`${API_BASE_URL}/config/all/branches`,'GET');
    }

    async searchMaterials(searchTerm, filters){
        let obj = {
            sort:[{"displayOrder" : "asc"}],
            searchTerm : searchTerm || ""
        };
        if(filters){
            obj.filters = filters;
        }
        return await Utilities.makeWebRequest(`${API_BASE_URL}/materials/search`,'POST', obj);
    }

    async searchActions(searchTerm, filters){
        return await Utilities.makeWebRequest(`${API_BASE_URL}/actions/search`,'POST', {
            sort:[{"createdAt" : "desc"}],
            searchTerm : searchTerm || "",
            filters : Utilities.isNullOrEmpty(filters) ? undefined : filters
        });
    }


    async getShopifyOrderData(startTime, endTime){
        return await Utilities.makeWebRequest(`${FIREBASE_FUNCTIONS_URL}/sales/shopify`,'POST', {
        startTime,
        endTime
        });
    }

    async saveEmail(email){
        return await Utilities.makeWebRequest(`${FIREBASE_FUNCTIONS_URL}/users/gotathome/subscribe`,'POST', { email });
    }
}

/* -- Random Other Store -- 6098 2306 4935[big chill], 6101[ours]*/
//1902[merchantId big chill] 4935[big chill]